module.exports = __webpack_public_path__ + "static/media/b-sci-major-30_LR.85cdf2e3.jpg";